import {BannerStackOutlet, BannerStackProvider, type BannerStackProviderProps} from '@github-ui/banner-stack'
import type {PropsWithChildren} from 'react'

import {DotcomLayoutRuntime} from '../dotcom-layout-runtime'
import {CollapsiblePageHeader} from './CollapsiblePageHeader'
import {
  SidebarPageLayout as CoreLayout,
  type HeaderBannerProps,
  type SidebarPageLayoutProps as CoreLayoutProps,
} from '@github-ui/layout-primitives-core'

export {
  useIsInsideSidebarPageLayout,
  useSidebarPageLayoutState,
  useSidebarPageLayoutActions,
  SidebarPageLayoutHeader,
  SidebarPageLayoutSidebarTrigger,
  SidebarPageLayoutSidebar,
  SidebarPageLayoutContent,
  SidebarPageLayoutFooter,
  type SidebarPageLayoutActionsHandle,
  type SidebarPageLayoutStateHandle,
  type SidebarPageLayoutHeaderProps,
  type SidebarFooterRenderArgs,
  type SidebarPageLayoutSidebarProps,
  type SidebarPageLayoutContentProps,
  type SidebarPageLayoutFooterProps,
  type SidebarPageLayoutSidebarTriggerProps,
  type HeaderBannerProps,
} from '@github-ui/layout-primitives-core'

export type SidebarPageLayoutProps = CoreLayoutProps & {
  /** Props passed to GitHub's banner stack provider. */
  bannerProviderProps?: Omit<BannerStackProviderProps, 'children'>
}

const DotcomBanners = ({focusFallbackRef}: HeaderBannerProps) => (
  <BannerStackOutlet focusFallbackRef={focusFallbackRef} className="mb-4" />
)

function Root({
  bannerProviderProps,
  headerBanner = DotcomBanners,
  showFooterBorder = true,
  ...props
}: PropsWithChildren<SidebarPageLayoutProps>) {
  return (
    <DotcomLayoutRuntime>
      <BannerStackProvider {...bannerProviderProps}>
        <CoreLayout {...props} headerBanner={headerBanner} showFooterBorder={showFooterBorder} />
      </BannerStackProvider>
    </DotcomLayoutRuntime>
  )
}

Root.displayName = 'SidebarPageLayout'
export const SidebarPageLayout = Object.assign(Root, {
  Header: CoreLayout.Header,
  PageHeader: CollapsiblePageHeader,
  SidebarTrigger: CoreLayout.SidebarTrigger,
  Sidebar: CoreLayout.Sidebar,
  Content: CoreLayout.Content,
  Footer: CoreLayout.Footer,
})
export const SidebarPageLayoutPageHeader = CollapsiblePageHeader
export {Root as SidebarPageLayoutRoot}
